import { ActionContext, Module } from "vuex";
import Ajax from "@/utils/DuduAjax";

import { API_BIS_IMPORT_PROGRESS, API_BIS_PATENTTEXT_PROGRESS } from "@/configs/Apis";
import { isEmptyOrWhiteSpace } from "@/utils/Common";

declare interface BaseTaskStatus {
    taskId: string
    projectId: string
    status: string
    count: number
    finished: number
    taskToken: string
}

declare interface ImportTaskStatus extends BaseTaskStatus {
    success: number
    finished: number
    failed: number
    skipped: number
    messages: Nullable<Array<string>>
}

const defaultImportTask = {
  status: "NOT_STARTED",
  count: 0,
  finished: 0,
  success: 0,
  failed: 0,
  skipped: 0,
  messages: null
};

const defaultPatentTextStatus = {
  status: "NOT_STARTED",
  count: 0,
  finished: 0
};

declare interface TaskState {
    importTask: ImportTaskStatus
    patentTextTask: BaseTaskStatus
}

const module: Module<TaskState, any> = {
  namespaced: true,
  state: {
    importTask: Object.assign({ taskId: "", projectId: "", taskToken: "" }, defaultImportTask),
    patentTextTask: Object.assign({ taskId: "", projectId: "", taskToken: "" }, defaultPatentTextStatus)
  },
  mutations: {
    importTask(state, payload) {
      state.importTask = payload;
    },
    patentTextTask(state, payload) {
      state.patentTextTask = payload;
    }
  },

  getters: {
    isProgress(state) {
      return state.importTask.status === "RUNNING" || state.patentTextTask.status === "RUNNING";
    }
  },

  actions: {
    progressImport(store, payload: { taskId: string, projectId: string }) {
      return requestProgress(store, API_BIS_IMPORT_PROGRESS, "importTask", payload, defaultImportTask);
    },
    progressPatentText(store, payload: { taskId: string, projectId: string }) {
      return requestProgress(store, API_BIS_PATENTTEXT_PROGRESS, "patentTextTask", payload, defaultPatentTextStatus);
    }
  }
};

function requestProgress(store: ActionContext<TaskState, any>, api: string, path: string, payload: { taskId: string, projectId: string }, defaultValue: any) {
  return new Promise((resolve, reject) => {
    let taskToken: any = "";

    if (!isEmptyOrWhiteSpace((store.state as any)[path].taskToken)) {
      clearTimeout((store.state as any)[path].taskToken as any);
    }

    store.commit(path, Object.assign({ taskId: payload.taskId, projectId: payload.projectId, taskToken }, defaultValue));

    if (isEmptyOrWhiteSpace(payload.taskId) || isEmptyOrWhiteSpace(payload.taskId)) {
      return reject("参数错误");
    }

    function progress() {
      Ajax.get<BaseTaskStatus>(api, { projectId: payload.projectId, taskId: payload.taskId }, false).then((message) => {
        if (message.status === "COMPLETED") {
          clearTimeout(taskToken);
          resolve();
        } else {
          taskToken = setTimeout(progress, 2000);
        }
        store.commit(path, Object.assign({ taskId: payload.taskId, projectId: payload.projectId, taskToken }, defaultValue, message));
      }).catch(() => "");
    }

    progress();
  });
}

export default module;
